import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { Select } from "../../form/select";

const types = [
   { id: 1, name: 'Select type', isActive: true, isHide: true },
   { id: 2, name: 'Chat Assistant', isActive: false },
   { id: 3, name: 'API Endpoint', isActive: false }
];

export function ExportProject({ handleValuesFeatures }: { handleValuesFeatures: (values: any) => void }) {
   const handleSelectLanguages = (selectId: number) => {
      if (selectId === 2) handleValuesFeatures({ isChat: true, isExport: false });
      else if (selectId === 3) handleValuesFeatures({ isAPI: true, isExport: false });
   }

   return (
      <div className="popup" onClick={ _=> handleValuesFeatures({ isExport: false }) }>
         <Main onClick={ e => e.stopPropagation() }>
            <div className="close" onClick={ _=> handleValuesFeatures({ isExport: false }) }>
               <FontAwesomeIcon icon={ faTimes } />
            </div>
            <h4>Workflow export type:</h4>
            <Select data={ types } handleSelectItem={ handleSelectLanguages } />
         </Main>
      </div>
   );
}

// ---
const Main = styled.div`
   width: 400px;

   .close {
      top: 10px;
      right: 10px !important;
   }
   h4 {
      font-weight: 400;
      margin-bottom: 15px;
   }
`;